export default __webpack_public_path__ + "static/media/question_02.c2fcc1e5.png";